import { render, staticRenderFns } from "./FeedItemReminder.vue?vue&type=template&id=a75e7c30&scoped=true&"
import script from "./FeedItemReminder.vue?vue&type=script&lang=js&"
export * from "./FeedItemReminder.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemReminder.vue?vue&type=style&index=0&id=a75e7c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75e7c30",
  null
  
)

export default component.exports